module.exports = __webpack_public_path__ + "img/banner-principal.db4e723a.svg";